/**
 * Multiple Link — block navigation on cards without links.
 * Footer links follow whole-card-click settings in Liquid; static footers are non-interactive.
 */
class MultipleLink extends HTMLElement {
  connectedCallback() {
    this._onStaticClick = this._onStaticClick.bind(this);
    this.querySelectorAll('.ml-compact-card--static, .ml-detailed-card--static .ml-detailed-card__hit').forEach((el) => {
      el.addEventListener('click', this._onStaticClick);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('.ml-compact-card--static, .ml-detailed-card--static .ml-detailed-card__hit').forEach((el) => {
      el.removeEventListener('click', this._onStaticClick);
    });
  }

  _onStaticClick(event) {
    event.preventDefault();
  }
}

if (!customElements.get('multiple-link')) {
  customElements.define('multiple-link', MultipleLink);
}
